/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancelwhite': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M10.95 10.152L6.798 6l4.152-4.152a.564.564 0 1 0-.798-.798L6 5.202 1.848 1.05a.564.564 0 1 0-.798.798L5.202 6 1.05 10.152a.564.564 0 1 0 .798.798L6 6.798l4.152 4.152a.564.564 0 1 0 .798-.798z" _fill="#fff" fill-rule="nonzero"/>'
  }
})
